import React from 'react';
import { Card as CheckoutCard } from 'primereact/card';
import PropTypes from 'prop-types';
import './checkoutCards.scss';
import deviceImg from '../assets/images/device.png';

export default function CheckoutCards({ title, price, checkList, devicePrice, numberOfDevices, loading, shippingPriceFee }) {
  const parsedPrice = parseFloat(price?.split('$')[1]);
  const totalDevicesPrice = numberOfDevices * devicePrice;
  const shippingPrice = numberOfDevices * shippingPriceFee;
  const finalPrice = parsedPrice + totalDevicesPrice + shippingPrice;

  return (
    <div className="card_main_container" id="checkoutCard">
      <CheckoutCard>
        <div className="card-header">{title}</div>
        <div className="card-underHeader">{price}</div>
        <div id="text-mark">
          <div className="pi">
            {checkList?.map(check => (
              <div key={check} className="textmark">
                <p>
                  <i className="pi pi-check p-mr-2" />
                  {check}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="image">
          <img alt="plan img" src={deviceImg} />
        </div>
        <>
          <div className="prices_container col-12 flex flex-column padding_0">
            <div className="flex justify-content-between sub-titles">
              <p className="price_small_text">Package Order: </p>
              <label className="price_small"> {price}</label>
            </div>
            <div>
              <div className="flex justify-content-between sub-titles">
                <p className="price_small_text">Shipping & Handling:</p>
                <label className="price_small">{loading ? 'Loading Price...' : `$ ${shippingPriceFee * numberOfDevices}`}</label>
              </div>
            </div>
            <div className="flex justify-content-between sub-titles">
              <p className="price_small_text">Device Price:</p>
              <label className="price_small">{loading ? 'Loading Price...' : `$ ${totalDevicesPrice}`}</label>
            </div>
          </div>
          <div className="final_price_box flex justify-content-between padding_0">
            <p>Due Now:</p>
            <label>{loading ? 'Loading...' : `$ ${finalPrice}*`}</label>
          </div>
          <p className="mt-4 text-left disclaimer">*pricing excludes applicable sales taxes</p>
        </>
      </CheckoutCard>
    </div>
  );
}

CheckoutCards.propTypes = {
  title: PropTypes.string,
  price: PropTypes.string,
  checkList: PropTypes.array,
  devicePrice: PropTypes.number,
  shippingPriceFee: PropTypes.number,
  numberOfDevices: PropTypes.number.isRequired,
  loading: PropTypes.bool,
};

CheckoutCards.defaultProps = {
  title: undefined,
  price: undefined,
  checkList: undefined,
  devicePrice: undefined,
  shippingPriceFee: undefined,
  loading: undefined,
};
